import { z } from 'zod';
export const HealthResponse = z.object({
    ok: z.literal(true),
    version: z.string(),
    uptimeSec: z.number().nonnegative(),
});
export * from './wallet.js';
export * from './prices.js';
export * from './article.js';
export * from './guide-sections.js';
export * from './ui-icons.js';
export * from './guide-screens.js';
export * from './guide-player.js';
export * from './guide-manual.js';
export * from './faq-figures.js';
export * from './rich-text.js';
export * from './locale-href.js';
export * from './country-page.js';
export * from './prices-page.js';
export * from './blog-post.js';
export * from './blog-structure.js';
export * from './blog-index.js';
export * from './home-page.js';
export * from './faq-page.js';
export * from './catalog-globals.js';
export * from './about-legal-page.js';
// The MCP version constant is the single place the server, the npm package and
// every discovery surface read from — it was hardcoded in four more files, and
// npm 1.6.3 shipped code that introduced itself as 1.6.0 because one of them
// was fixed and the artifact never rebuilt.
export { ROAMZY_MCP_VERSION } from './mcp-core.js';
